// Loader.js
import React from 'react';
import LoaderImg from "../Assets/giphy.gif"
const Loader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
      <div className="text-center">
        <img
        loading="lazy"
        role="presentation"
        decoding="async"
        fetchpriority="high" src={LoaderImg} alt="Loading..." className="mb-3" style={{ width: '80px' }} />
        <p className="text-muted">Loading, please wait...</p>
      </div>
    </div>
  );
};

export default Loader;
